// @flow
import styled from 'styled-components';

export const Buttons = styled.ul`
    display: flex;

    li:last-child {
        margin-left: 1em;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/humidity-control-modal/style.js